import { readStorageJson } from '../../../utils/safeJson'

export function getPanelsPath() {
  return readStorageJson('panelsPath', {})
}

export function savePath(key, value, keysToRemove) {
  const result = getPanelsPath()
  result[key] = value
  if (keysToRemove.length) {
    keysToRemove.forEach((k) => delete result[k])
  }
  localStorage.setItem('panelsPath', JSON.stringify(result))
}
